import { apiClient } from '../lib/api-client';

/**
 * Wire-format payload for the password-reset / email-verification flows.
 * Each helper mirrors the BFF v3 endpoint signature 1:1.
 *
 * @see HZVT-150_ADD_AUTH_PASSWORD_RESET_AND_EMAIL_VERIFICATION
 */
export interface ForgotPasswordPayload {
  email: string;
}

export interface ResetPasswordPayload {
  token: string;
  newPassword: string;
}

export interface VerifyEmailPayload {
  token: string;
}

/**
 * BFF response shapes — kept narrow so consumers don't accidentally rely
 * on fields the auth service may stop returning.
 */
export interface ForgotPasswordResponse {
  ok: true;
}

export interface ResetPasswordResponse {
  userId: string;
  email: string;
}

export interface VerifyEmailResponse {
  userId: string;
  email: string;
}

/**
 * REST helpers for the HZVT-150 password-reset + email-verification
 * flows. Routed via the BFF (`/auth/v3/...`) which delegates to the auth
 * microservice through TCP. None of these endpoints require an
 * authenticated session — `apiClient` will still attach the access
 * token if present, but the BFF accepts the call regardless.
 */
export const passwordResetApi = {
  /** Initiate a password reset — always returns `{ ok: true }`. */
  forgotPassword: (payload: ForgotPasswordPayload) =>
    apiClient.post<ForgotPasswordResponse>('/auth/v3/forgot-password', payload),

  /** Redeem a reset token and apply the new password. */
  resetPassword: (payload: ResetPasswordPayload) =>
    apiClient.post<ResetPasswordResponse>('/auth/v3/reset-password', payload),

  /** Redeem an email-verification token. */
  verifyEmail: (payload: VerifyEmailPayload) =>
    apiClient.post<VerifyEmailResponse>('/auth/v3/verify-email', payload),
};
